import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["file", "gatsbyFile", "description", "altText"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _has from 'lodash/has';
import _omit from 'lodash/omit';
export function businessFileToImageProps(images) {
  return (images || []).map(function (image) {
    var file = image.file,
      gatsbyFile = image.gatsbyFile,
      description = image.description,
      altText = image.altText,
      restFile = _objectWithoutProperties(image, _excluded);
    var baseImage = _objectSpread(_objectSpread({}, restFile), {}, {
      altText: altText || description || ''
    });
    if (gatsbyFile) {
      return _objectSpread(_objectSpread({}, baseImage), {}, {
        src: gatsbyFile.childImageSharp
      });
    }
    return _objectSpread(_objectSpread({}, baseImage), {}, {
      src: file
    });
  });
}
export function getGatsbyImageStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parentStyles = {};
  var childStyles = _objectSpread({}, style);
  function moveStyleToParent(styleName) {
    if (_has(style, styleName)) {
      childStyles = _omit(childStyles, styleName);
      parentStyles = _objectSpread(_objectSpread({}, parentStyles), {}, _defineProperty({}, styleName, style[styleName]));
    }
  }
  moveStyleToParent('boxShadow');
  moveStyleToParent('border');
  moveStyleToParent('borderRadius');
  moveStyleToParent('width');
  moveStyleToParent('height');
  moveStyleToParent('minHeight');
  moveStyleToParent('maxHeight');
  moveStyleToParent('maxWidth');
  moveStyleToParent('minWidth');
  moveStyleToParent('margin');
  return {
    parentStyles: parentStyles,
    childStyles: childStyles
  };
}